import React from 'react';
import { Mail, Bot, X } from 'lucide-react';

interface ChatHeaderProps {
  botName: string;
  botSubtitle: string;
  showSettings: boolean;
  onStartContactForm: () => void;
  onToggleChat: () => void;
  isContactFormMode?: boolean;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  botName,
  botSubtitle,
  showSettings,
  onStartContactForm,
  onToggleChat,
  isContactFormMode = false
}) => {
  return (
    <div className="chat-header text-white flex items-center justify-between">
      <div className="flex items-center">
        <div className="bg-white/20 p-2 rounded-full mr-3">
          <Bot size={20} className="text-white" />
        </div>
        <div>
          <h3 className="font-medium text-base">{botName}</h3>
          <p className="text-xs text-blue-100 opacity-90 flex items-center">
            {isContactFormMode ? (
              'Formulário de Contato'
            ) : (
              <>
                <span className="online-status-dot"></span>
                {botSubtitle}
              </>
            )}
          </p>
        </div>
      </div>
      
      <div className="flex items-center">
        <button
          onClick={onStartContactForm}
          className={`p-2 rounded-full mr-1 transition-colors ${
            isContactFormMode 
              ? 'opacity-50 cursor-not-allowed envelope-button-disabled' 
              : 'hover:bg-white/10 cursor-pointer'
          }`}
          aria-label="Formulário de contato"
          disabled={isContactFormMode}
          title={isContactFormMode ? "Formulário de contato já está em andamento" : "Iniciar formulário de contato"}
        >
          <Mail size={18} />
        </button>
        
        <button
          onClick={onToggleChat}
          className="p-2 rounded-full hover:bg-white/10 transition-colors"
          aria-label="Fechar chat"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
